module.exports = __webpack_public_path__ + "img/pdf_preview_gastro_en.dc6e5c68.png";